
import Vue from "vue";

export default Vue.extend({
  name: "RadioGroupField",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      default: () => {
        return [];
      },
    },
    required: {
      type: Boolean,
      default: false,
    },
    extraValidations: {
      type: Boolean,
      default: false,
    },
    validation: {
      type: String,
      default: ""
    },
    score: {
      type: Boolean,
      default: false,
    },
    scores: {
      type: Array,
      default: () => {
        return [];
      },
    },
    value: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      selectedOption: this.value,
    };
  },
  methods: {
    updateValue(value: any) {
      this.$emit("input", value);
    },
  },
  watch: {
    value: function (value) {
      this.selectedOption = value;
    },
    selectedOption: function (nOption) {
      this.selectedOption = nOption;
      this.$emit("input", nOption);
    },
  },
});
